module.exports = {
  defaultLang: "en-us",
  langs: ["en-us", "ro", "de-at"],
  languages: [
    { label: "EN", locale: "en-us" },
    { label: "RO", locale: "ro" },
    { label: "AT", locale: "de-at" },
    { label: "CH", locale: "de-ch" }
  ]
}
